// Language catalog shared with mobile (assets/languages.json). Flag images
// are replaced by emoji derived from the ISO country code.
import languagesJson from '@assets/languages.json';

export interface LanguageOption {
  language: string;
  code: string | null;
  flag: string;
}

export const LANGUAGES: LanguageOption[] = languagesJson.languages;

/** "us" → 🇺🇸 (regional-indicator emoji). Empty string for no flag. */
export const flagEmoji = (countryCode: string): string =>
  countryCode
    ? String.fromCodePoint(
        ...countryCode
          .toUpperCase()
          .split('')
          .map(c => 0x1f1e6 + c.charCodeAt(0) - 65),
      )
    : '🌐';

export const languageName = (code: string | null): string | null => {
  if (!code) {
    return null;
  }
  return LANGUAGES.find(lang => lang.code === code)?.language ?? code;
};
